import {
    SuffolkRecordType,
    SuffolkRecordSubType
} from "./SuffolkRecordTypes";
import { IStyleFactory } from "@esdm/map/dist/layers/vector/styles/IStyleFactory";
import Style, { StyleFunction } from "ol/style/Style";
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Stroke from 'ol/style/Stroke';
import RegularShape from "ol/style/RegularShape";


export class HbsmrStyleFactory implements IStyleFactory {

    public getStyle(recordType: string, recordSubType: string = null): Style[]
    {
        let style: Style[] = null;

        //try and resolve sub type first
        if (recordSubType !== null) {
            switch (recordSubType) {               

                case SuffolkRecordSubType.ListedBuilding:
                    style = this.ListedBuilding();
                    break;

                case SuffolkRecordSubType.ScheduledMonument:
                    style = this.ScheduledMonument();
                    break;
                              
                case SuffolkRecordSubType.RegisteredParksAndGardens:
                    style = this.RegisteredParksAndGardens();
                    break;

                case SuffolkRecordSubType.Shine:
                    style = this.Shine();
                    break;

            }
        }

        if (style === null) {
            switch (recordType) {
                case SuffolkRecordType.Monument:
                    style = this.Monument();
                    break;

                case SuffolkRecordType.Event:
                    style = this.Event();
                    break;

                case SuffolkRecordType.Designation:
                    style = this.Designation();
                    break;

                case SuffolkRecordType.Consultation:
                    style = this.Consultation();
                    break;
            }
        }

        return style;
    }

    public getSelectedStyle(
        recordType: string = SuffolkRecordType.Monument): Style[]
    {        
        return this.SelectedRecord();
    }

    private CommonStyle(fillColour: string): Style[] {
        var fill = new Fill({
            color: fillColour
        });
        var stroke = new Stroke({
            color: 'rgba(255,255,255,1)',
            width: 3
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 12
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    
    private Monument(): Style[] {      
        var fill = new Fill({
            //color: 'rgba(66, 94, 143,0.4)'
            color: 'rgba(255, 0, 0,0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(255,0,0,1)',
            width: 2
        });

        return   [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];

    }

    private Event(): Style[] {       
        var fill = new Fill({
            color: 'rgba(0, 0, 255, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(0, 0, 255, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Designation(): Style[] {
        return this.CommonStyle('rgba(132, 71, 15,0.4)');
    }

    private ListedBuilding(): Style[] {
        var fill = new Fill({
            color: 'rgba(128, 64, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(128, 64, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Consultation(): Style[] {
        //return this.CommonStyle('rgba(27, 15, 220, 0.4)');   
        var fill = new Fill({
            color: 'rgba(0, 0, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(0, 0, 0, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private ScheduledMonument(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 0, 255, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(255, 0, 255, 1)',
            width: 2
        });

        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }
    
    private RegisteredParksAndGardens(): Style[] {
        //return this.CommonStyle('rgba(45, 123, 9,0.5)');   
        var fill = new Fill({
            color: 'rgba(56, 223, 47, 0.3)'
        });

        var stroke = new Stroke({
            color: 'rgba(56, 223, 47, 1)',
            width: 2
        });
                
        return [new Style({
            image: new RegularShape({
                fill: fill,
                stroke: stroke,
                points: 5,
                radius: 8,
                radius2: 4,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }

    private Shine(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 128, 0, 0.4)'
        });
        var stroke = new Stroke({
            color: 'rgba(255, 128, 0, 1)',
            width: 2
        });
       
        return [new Style({
            image: new RegularShape({
                fill: new Fill({ color: 'rgba(255, 128, 0, 0.4)' }),
                stroke: new Stroke({ color: 'rgba(255, 128, 0, 1)', width: 2 }),
                points: 3,
                radius: 10,
                rotation: 0,
                angle: 0
            }),
            fill: fill,
            stroke: stroke
        })];
    }
    
    private SelectedRecord(): Style[] {
        var fill = new Fill({
            color: 'rgba(255, 255, 0, 0.6)'
        });

        return [
            new Style({
                image: new Circle({
                    fill: fill,
                    stroke: new Stroke({
                        color: 'rgba(255, 173, 10, 1)',
                        width: 3
                    }),
                    radius: 10
                }),
                fill: fill,
                stroke: new Stroke({
                    color: 'rgba(255, 173, 10, 1)',
                    width: 3
                })
            })
        ];
    }

}
